import _defineProperty from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { createGlobalStyle } from 'styled-components';
import { kleinBlue, gold, fuchsia, black } from '@spotify-internal/encore-foundation';
import { DEFAULT_SOCIAL_CARD } from '../../../../features/Layout/PageHead';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var goldHighlight = '#fbb250';
var kleinBlueActive = '#2E00AC';
var kleinBlueHighlight = '#7140F8';
var fuchsiaHighlight = 'rgb(229, 79, 169)';
var fuchsiaActive = 'rgb(154, 14, 98)';
var defaultTitle = process.env.REACT_APP_TITLE;
var defaultImage = DEFAULT_SOCIAL_CARD;
var pageHeadDefaultProps = {
  title: []
}; // Apply gold theme
// eslint-disable-next-line no-unused-expressions

export var PageHeadStyles = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\n  .nav-tabs li.active a::after,\n  .no-touchevents .nav-tabs li:active a::after,\n  .no-touchevents .nav-tabs li:hover a::after {\n    background: ", ";\n  }\n\n  a:focus,\n  a:hover {\n    &,\n    .footer-default .nav &,\n    .navbar-default .navbar-nav .open .dropdown-menu>li> & {\n      color: ", ";\n    }\n  }\n\n  a.external {\n    color: ", ";\n\n    &::after {\n      background-image: url('data:image/svg+xml;utf8,<svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\"><title>Arrow</title><g stroke=\"", "\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M1 9l8-8\"/><path stroke-linejoin=\"round\" d=\"M2 .998h7V8\"/></g></svg>')\n    }\n\n    &:hover {\n      color: ", ";\n    }\n  }\n\n  .btn-green {\n    background-color: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n\n    &:active,\n    &:focus {\n      &,\n      &:hover {\n        background-color: ", ";\n      }\n    }\n  }\n\n  .btn-fuchsia {\n    background-color: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n\n    &:active,\n    &:focus {\n      &,\n      &:hover {\n        background-color: ", ";\n      }\n    }\n  }\n"])), black, goldHighlight, gold, goldHighlight, goldHighlight, kleinBlue, kleinBlueHighlight, kleinBlueActive, fuchsia, fuchsiaHighlight, fuchsiaActive);
export default function PageHead(props) {
  var t = useT();
  var router = useRouter();
  var title = [].concat(_toConsumableArray(props.title), [defaultTitle]).join(' – ');
  var description = props.description || t('FRODOR_APP_DESCRIPTION', 'Get more out of Spotify with tools & tips for artists and their teams.', 'Application description');
  var image = (props.image || defaultImage || '').replace(/^\/\//, 'https://') || null;

  var linkedData = props.linkedData && _objectSpread({
    '@context': 'http://schema.org'
  }, props.linkedData);

  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("title", {
      children: title
    }, "title"), /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: description
    }, "meta.description"), /*#__PURE__*/_jsx("meta", {
      name: "apple-itunes-app",
      content: "app-id=1222021797"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:app:id:googleplay",
      content: "com.spotify.music"
    }), /*#__PURE__*/_jsx("meta", {
      name: "og:title",
      content: title
    }, "meta.og:title"), /*#__PURE__*/_jsx("meta", {
      name: "og:description",
      content: description
    }, "meta.og:description"), /*#__PURE__*/_jsx("meta", {
      name: "og:image",
      property: "og:image",
      content: image
    }, "meta.og:image"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:card",
      content: "summary_large_image"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:title",
      content: title
    }, "meta.twitter:title"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:image",
      content: image
    }, "meta.twitter:image"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:description",
      content: description
    }, "meta.twitter:description"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:site",
      content: "@spotifyartists"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:app:id:iphone",
      content: "324684580"
    }), /*#__PURE__*/_jsx("meta", {
      name: "twitter:app:id:googleplay",
      content: "com.spotify.music"
    }), /*#__PURE__*/_jsx("link", {
      rel: "alternate",
      type: "application/rss+xml",
      title: "".concat(t('FRODOR_legacy-pagehead-1', 'All Posts', 'A collection of blog posts'), " \u2013 ").concat(t('FRODOR_legacy-pagehead-2', 'News', 'News'), " \u2013 ").concat(t('FRODOR_legacy-pagehead-3', 'Spotify for Artists', 'Spotify for Artists')),
      href: "".concat(router.locale ? "/".concat(router.locale) : '', "/blog.rss")
    }, "link.blogUrl"), linkedData && /*#__PURE__*/_jsx("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(linkedData)
      }
    }, "script.linkedData"), props.children]
  });
}
PageHead.defaultProps = pageHeadDefaultProps;